import http from "../requestBase";
import "../types/typdefs";

const API_BASE = "api/SurveyInstancesAnswers";

/**
 * Gets a SurveyInstance with the id "id"
 * @param {number} id
 * @param {String} lang
 * @returns {Promise<SurveyInstanceData>}
 */
function getById(id, lang = "en") {
  return http.get(`${API_BASE}/${id}?localeCode=${lang}`);
}

/**
 * Update the SurveyInstance with the id "id"
 * @param {Nnumber} id The SurveyInstanceId
 * @param {SurveyInstanceData} content
 * @returns
 */
function update(id, content) {
  return http.put(`${API_BASE}/${id}`, content);
}

let View = {
  getById,
  update,
};

export default View;



// WEBPACK FOOTER //
// ./src/services/SurveyInstances/View.js